import React, { useState, useEffect } from 'react';

import Input from  'xpi-black-ui/Base/Input';
import Select from  'xpi-black-ui/Base/Select';
import { P } from 'xpi-black-ui/Base/Typography';
import { Tr, Td } from 'xpi-black-ui/Common/Table';
import { SingleDatePicker } from 'xpi-black-ui/Common/DatePicker';

import { typesStrikeEnum } from '../../../../../../../enums';

import { convertToCurrency, convertNumberBR, maskMoney, removeMask, maskPercentage, removeMaskPercentage, disableDayBiggerOndeYear } from 'utils/helpers';

const natures = [
  { label: 'Compra', value: 'C' },
  { label: 'Venda', value: 'V' }
];

const types = [
  { label: 'Call', value: 22 },
  { label: 'Put', value: 33 },
  { label: 'Spot', value: 35 }
];

function Leg({ leg, updateLeg, typeStrike, willChangeValue }) {
  const typeSelected = types.find(type => type.value === leg?.opcao?.value);
  const natureSelected = natures.find(nature => nature.value === leg?.operacao);

  const [type, setType] = useState(typeSelected);
  const [nature, setNature] = useState(natureSelected);
  const [maturityDate, setMaturityDate] = useState(leg?.maturityDate);
  const [strike, setStrike] = useState({
    view: leg?.strike?.view,
    converted: leg?.strike?.converted || '',
    value: leg?.strike?.value || leg?.strike,
  });
  const [quantity, setQuantity] = useState({
    view: leg?.quantity.view || leg?.quantity,
    value: leg?.quantity?.value || leg?.quantity
  });

  const getNumberTarget = (value) => {
    const matchNumbers = value?.toString().match(/[\d]/gi,'');
    return matchNumbers ? Number(matchNumbers.join('')) : 0;
  };

  const willChangeLeg = (callback) => {
    willChangeValue(callback);
  };

  const onChangeQuantity = (value) => {
    const changeQuantity = () => {
      if (!Number.isNaN(value)) {
        const naturalValue = getNumberTarget(value);
        let quantity = parseFloat(naturalValue || 0);
        let quantityView = convertNumberBR(naturalValue);

        setQuantity({ view: quantityView, value: quantity });
      }
    };

    willChangeLeg(changeQuantity);
  };

  const onChangeStrike = (value) => {
    const changeStrike = () => {
      if (!Number.isNaN(value) && value) {
        let valueView, valueNumber, valueConverted, viewConverted;

        if (typeStrike === typesStrikeEnum.amount) {
          valueView = maskMoney(value);
          valueNumber = removeMask(valueView);
          valueConverted = Number(((valueNumber * 100) / leg?.spot).toFixed(2));
          viewConverted = `${convertNumberBR(valueConverted)} %`;
        } else {
          viewConverted = maskPercentage(value);
          valueNumber = removeMaskPercentage(value);
          valueView = convertToCurrency(leg?.spot * (valueNumber / 100));
        }

        setStrike({ view: valueView, value: valueNumber, valueConverted, viewConverted });
      }
    }
    willChangeLeg(changeStrike);
  };

  const onChangeValueLeg = ({ value, setProperty }) => {
    const changeProperty = () => setProperty(value);
    willChangeLeg(changeProperty);
  };

  useEffect(() => {
    const legUpdated = {
      ...leg,
      strike,
      quantity,
      maturityDate,
      opcao: type.value,
      compraAtivo: type.label === 'Spot',
      operacao: nature?.value || leg?.operacao,
    }
    updateLeg(legUpdated);
  }, [nature, quantity, type, maturityDate, strike]);

  useEffect(() => {
    if (leg?.strike && !strike?.viewConverted) {
      onChangeStrike(leg?.strike?.view);
    }
  }, [leg]);

  return (
    <Tr>
      <Td>{leg?.asset}</Td>
      <Td>{leg?.spotFormatted}</Td>
      <Td>
        <Select
          value={nature}
          options={natures}
          placeholder="Selecione"
          onChange={value => onChangeValueLeg({ value, setProperty: setNature })}
        />
      </Td>
      <Td>
        <Input
          value={quantity.view}
          style={{ width: '100%' }}
          onChange={e => onChangeQuantity(e.target.value)}
        />
      </Td>
      <Td>
        <Select
          value={type}
          options={types}
          placeholder="Selecione"
          onChange={value => onChangeValueLeg({ value, setProperty: setType })}
        />
      </Td>
      {!leg.compraAtivo ? (
        <>
          <Td>
            <SingleDatePicker
              date={maturityDate}
              placeholder="Selecione"
              isOutsideRange={day => disableDayBiggerOndeYear(day)}
              onChange={value => onChangeValueLeg({ value, setProperty: setMaturityDate })}
            />
          </Td>
          <Td>
            {typeStrike === typesStrikeEnum.amount
              ?
                <Input
                  value={strike.view}
                  placeholder="R$ 0,00"
                  onChange={(e) => onChangeStrike(e.target.value)}
                />
              : <P style={{ marginLeft: '10px' }}>{strike?.view || '-'}</P>
            }
          </Td>
          {!leg?.reverse && (
            <Td>
              {typeStrike === typesStrikeEnum.percentage
                ?
                  <Input
                    value={strike.viewConverted}
                    placeholder="0,00 %"
                    onChange={(e) => onChangeStrike(e.target.value)}
                  />
                : <P style={{ marginLeft: '10px' }}>{strike?.viewConverted || '-'}</P>
              }
            </Td>
          )}
        </>
      )
      :
       <>
        <Td />
        <Td />
        {!leg?.reverse && (<Td />)}
       </>
      }
    </Tr>
  );
}

export default Leg;
